export const USER_ROLES = {
  ADMIN: 'admin',
  SCHOOL_STAFF: 'school_staff',
  DOCTOR: 'doctor',
};

export const EVENT_STATUS = {
  UPCOMING: 'upcoming',
  ONGOING: 'ongoing',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
};

export const ORAL_HYGIENE = {
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
};

export const JAW_DEVELOPMENT = {
  GOOD: 'good',
  TO_BE_ASSIGNED: 'to_be_assigned',
};

export const JAW_WIDTH = {
  WIDE: 'wide',
  NARROW: 'narrow',
};

export const TONGUE_MOVEMENT = {
  GOOD: 'good',
  DYSFUNCTION: 'dysfunction',
  RESTRICTED: 'restricted',
};

export const MOUTH_BREATHING = {
  YES: 'yes',
  NO: 'no',
};

export const STATUS_COLORS = {
  upcoming: 'cyan',
  ongoing: 'green',
  completed: 'default',
  cancelled: 'red',
  active: 'green',
  inactive: 'default',
  suspended: 'red',
};

export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];
export const DEFAULT_PAGE_SIZE = 10;
